export default "__VITE_ASSET__sgDx_38D__"